module.exports = __webpack_public_path__ + "img/RetuscheBearbeitet.ddb829e9.jpg";